<script>
  import Carousel from '@beyonk/svelte-carousel';
</script>

<div class="carousel-container">
  <div class="carousel__inner">
    <Carousel loop={true} dots={false} perPage={1} autoplay={6000} duration={1000} draggable={false}>
      <div class="carousel__slide">
        <div>
          <h4 class="carousel__quote">
            “This is amazing I love having the chance to buy from businesses I can't otherwise access, and I've never gotten food deliveries so quickly!”
            <!-- <span class="carousel__quote-author">– Miss Piggy</span> -->
          </h4>
        </div>
      </div>
      <div class="carousel__slide">
        <div>
          <h4 class="carousel__quote">
            "We cook all the time because we get such average food everywhere else, but your food has not failed! So many cuisines and all have been amazing."
            <!-- <span class="carousel__quote-author">– Mariah Carey</span> -->
          </h4>
        </div>
      </div>
      <div class="carousel__slide">
        <div>
          <h4 class="carousel__quote">
            "You guys are the bomb - I'll email front of house in hopes you're here as much as possible!”
            <!-- <span class="carousel__quote-author">– Sammy Davis, Jr.</span> -->
          </h4>
        </div>
      </div>
    </Carousel>
  </div>
</div>

<style>
  .carousel-container {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .carousel-container :global(.slides > div) {
    display: flex;
  }

  .carousel-container :global(.slides > div div) {
    display: flex;
    align-items: stretch;
  }

  .carousel__inner {
    width: 700px;
  }

  .carousel__slide {
    width: 100%;
    align-items: center !important;
    justify-content: center;
  }

  .carousel__quote {
    font-size: 26px;
    margin: 0;
    color: #ffffff;
  }

  .carousel__quote-author {
    font-size: 18px;
    margin: 0;
    color: #ffffff;
  }

  @media only screen and (max-width: 1024px) {
    .carousel-container {
      display: none;
    }
  }
</style>
